import { render, staticRenderFns } from "./ApplyDetail.vue?vue&type=template&id=2209e328&scoped=true"
import script from "./ApplyDetail.vue?vue&type=script&lang=js"
export * from "./ApplyDetail.vue?vue&type=script&lang=js"
import style0 from "./ApplyDetail.vue?vue&type=style&index=0&id=2209e328&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2209e328",
  null
  
)

export default component.exports